import { UsersComponent } from './usersComponent/users.component';
import { UserDetailsComponent } from './userDetailsComponent/user-details.component';
import { LoginComponent } from './loginComponent/login.component';

const USER_COMPONENTS: any[] = [
    LoginComponent,
    UserDetailsComponent,
    UsersComponent,
];

export {
    USER_COMPONENTS,

    UserDetailsComponent,
    UsersComponent,
    LoginComponent
};



// WEBPACK FOOTER //
// ./src/app/features/userManagement/userManagement.ts